import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const DayWorkSource = union([
    literal("any"),
    literal("tasks"),
    literal("key_dates"),
    literal("roadblocks"),
]);
export type TDayWorkSourceCodec = typeof DayWorkSource;
export type TDayWorkSource = TTypeOfCodec<TDayWorkSourceCodec>;
